export default "__VITE_ASSET__BE2XY85t__"